import { Select } from "@/components/flexkit/select/Select";
import { type FC } from "react";

// eslint-disable-next-line react-refresh/only-export-components
export enum WorkflowStatusFilterValue {
    All = "all",
    Running = "running",
    Completed = "completed",
}

function toWorkflowStatusFilterValue(value: string): WorkflowStatusFilterValue {
    if (isWorkflowStatusFilterValue(value)) {
        return value;
    }
    // defaulting to 'All' if the value is unrecognized
    return WorkflowStatusFilterValue.All;
}

function isWorkflowStatusFilterValue(value: string): value is WorkflowStatusFilterValue {
    return Object.values(WorkflowStatusFilterValue).includes(value as WorkflowStatusFilterValue);
}

const statusFilterOptions = [
    {
        value: WorkflowStatusFilterValue.All,
        label: "All",
    },
    {
        value: WorkflowStatusFilterValue.Running,
        label: "Running",
    },
    {
        value: WorkflowStatusFilterValue.Completed,
        label: "Completed",
    },
];

type WorkflowStatusFilterProps = {
    value: WorkflowStatusFilterValue;
    onChange: (value: WorkflowStatusFilterValue) => void;
};

export const WorkflowStatusFilter: FC<WorkflowStatusFilterProps> = ({ value, onChange }) => {
    return (
        <Select
            data-testid="workflow-status-filter-trigger"
            value={value}
            onValueChange={(v) => onChange(toWorkflowStatusFilterValue(v))}
            placeholder="Select status"
            formatDisplayValue={(_, label) => <span>Status: {label}</span>}
        >
            {statusFilterOptions.map((option) => (
                <Select.Item key={option.value} value={option.value}>
                    {option.label}
                </Select.Item>
            ))}
        </Select>
    );
};
